@switch (level) {
  @case (1) { <h1>{{ value }}</h1> }
  @case (2) { <h2>{{ value }}</h2> }
  @case (3) { <h3>{{ value }}</h3> }
  @case (4) { <h4>{{ value }}</h4> }
  @case (5) { <h5>{{ value }}</h5> }
  @case (6) { <h6>{{ value }}</h6> }
  @default { <h1>{{ value }}</h1> }
}